<template>
  <div id="side-menu" :class="{ visible: isVisible }">
    <a v-if="isVisible" id="side_menu_close_button" href="#" @click.prevent="$emit('close-side-menu')">&gt;</a>

    <div v-if="isVisible" id="side-menu-content">
      <PinForm
        v-if="editMode"
        :pin="editPin"
        :pins-url="pinsUrl"
        @pin-created="$emit('pin-created', $event)"
        @pin-updated="$emit('pin-updated', $event)"
        @pin-selected="$emit('pin-selected', $event)"
        @pin-center="$emit('pin-center', $event)"
      />
      <PinInfos
        v-else-if="pin"
        :pin="pin"
        @edit-pin="$emit('edit-pin', $event)"
        @delete-pin="$emit('delete-pin', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import PinForm from './PinForm.vue'
import PinInfos from './PinInfos.vue'

defineProps({
  pin: Object,
  editPin: {
    type: Object,
    required: true,
  },
  editMode: {
    type: Boolean,
    required: true,
  },
  isVisible: {
    type: Boolean,
    required: true,
  },
  pinsUrl: {
    type: String,
    required: true,
  },
})

defineEmits([
  'close-side-menu',
  'delete-pin',
  'edit-pin',
  'pin-center',
  'pin-created',
  'pin-selected',
  'pin-updated',
])
</script>
